import type {FieldPolicy} from '@apollo/client';

import {CachedMsgNode} from '../msgNode';

/**
 * Merge for the message destination node.
 */
export const destination: FieldPolicy<CachedMsgNode> = {
  keyArgs: (a) => a?.account?.__ref,
  merge: true,
};

/**
 * Merge for the message source node.
 */
export const source: FieldPolicy<CachedMsgNode> = {
  keyArgs: (a) => a?.account?.__ref,
  merge: true,
};
